import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../Components/checkbox/Checkbox";
import ApiDropdown from "../../Components/DropDown/Apidropdown";
import FileUploader from "../../Components/FileUpload/FileUpload";
import Input from "../../Components/input/input";
import TaskGridLookup from "../../Components/Lookup/Lookup"; // Adjust the path based on your project structure
import config from "../../config";
import "../../Style/IncidentAdd.css";
import { ChangeData } from "../../utils/Change/changeTypes";
import { TaskData } from "../../utils/Task/taskTypes";
import { useFetchFullName } from "../Incidents/Hooks/useFetchFullName";
import { KnowledgeBase, initialKnowledgeBase } from "./KnowledgeBase";
import { RmaData } from "../../utils/Rma/rmaTypes";
import { KnowledgeBaseData } from "../../utils/KnowledgeBase/KnowledgeBaseTypes";
import { IncidentData } from "../../utils/Incident/incidentTypes";
import { ProblemData } from "../../utils/Problem/problemTypes";
import { authFetch } from "../../utils/Security/authFetch";
import { joinMulti } from "../../utils/multiValue";
import TextArea from "../../Components/TextArea/TextArea";

const KnowledgeBaseAdd: React.FC = () => {
  const username = localStorage.getItem("username");
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const isUser = localStorage.getItem("isUser") === "true";
  const [knowledgeBase, setKnowledgeBase] =
    useState<KnowledgeBase>(initialKnowledgeBase);
  const [showUserDialog, setShowUserDialog] = useState(false);
  const [customer, setCustomer] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [emails, setEmails] = useState<[]>();
  const organization = localStorage.getItem("organization") || undefined;

  const navigate = useNavigate();
  const [isTaskLookupOpen, setIsTaskLookupOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState<
    (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  >([]);
  const [network, setNetwork] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [site, setSite] = useState<
    string | number | (string | number)[] | null
  >(null);

  const handleOpenTaskLookup = () => setIsTaskLookupOpen(true);
  const handleCloseTaskLookup = () => setIsTaskLookupOpen(false);

  const handleTaskSelect = (
    tasks: (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  ) => {
    const ticketIds = tasks.map((t) => t.ticketId); // collect all selected ticketIds
    handleChange("relatedobject", ticketIds); // now this should be an array
    setSelectedTask(tasks); // you might rename this to selectedTasks now
  };
  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    const storedPosition = localStorage.getItem("position") ?? "";
    if (storedUsername) {
      setKnowledgeBase((prev) => ({
        ...prev,
        createdby: storedUsername,
        responsiblePerson: storedUsername,
        responsibleTeam: storedPosition,
      }));
    }
  }, []);

  useFetchFullName((fullName: string) => {
    setKnowledgeBase((prev) => ({ ...prev, user: fullName }));
  });

  const handleChange = (field: keyof KnowledgeBase, value: any) => {
    setKnowledgeBase((prev) => ({ ...prev, [field]: value }));
  };
  const validateForm = (): boolean => {
    if (!knowledgeBase) {
      alert("KnowledgeBase data is not available.");
      return false;
    }

    const requiredFields: (keyof KnowledgeBase)[] = ["summary", "description"];

    for (const field of requiredFields) {
      const value = knowledgeBase[field];
      if (
        value === undefined ||
        value === null ||
        value.toString().trim() === ""
      ) {
        alert(`Please fill the required field`);
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    console.log("Submitting KnowledgeBase:", knowledgeBase); // Log the state before submission

    try {
      const response = await authFetch(
        `${config.apiBaseUrl}/api/knowledgeBases`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(knowledgeBase),
        }
      );
      if (knowledgeBase) {
        try {
          await authFetch(`${config.apiBaseUrl}/api/email/send`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },

            body: JSON.stringify({
              to: knowledgeBase,
              //  emails
              subject: `An knowledgeBase with ID ${knowledgeBase.ticketId} has been added to you.`,
              body: `
              Customer: ${knowledgeBase.affectedCustomer} <br>
              Network: ${knowledgeBase.affectedNetwork} <br>
              Site: ${knowledgeBase.affectedSite} <br>
              Link: ${knowledgeBase.affectedLink} <br>
              KnowledgeBase Start Date: ${knowledgeBase.knowledgeBaseStartDatetime} <br>
              Summary: ${knowledgeBase.summary} <br>
              Description: ${knowledgeBase.description} <br>
              Communication with customers: ${knowledgeBase.communicationWithCustomer} <br>
    
              <br>
              Regards, <br>
              
            `,
            }),
          });
          //console.log("Email sent successfully!");
        } catch (emailErr) {
          console.error("Failed to send email notification:", emailErr);
        }
      }

      if (!response.ok) throw new Error("Failed to submit knowledgeBase");

      alert("KnowledgeBase submitted successfully!");
      setKnowledgeBase({
        ...initialKnowledgeBase,
        ticketId: knowledgeBase.ticketId,
      }); // reset but keep ticket ID
      navigate("/knowledgeBase");
    } catch (error) {
      alert(`Submission error: ${(error as Error).message}`);
      console.error(`Submission error: ${(error as Error).message}`);
    }
  };

  // Generate Ticket ID once
  useEffect(() => {
    if (!knowledgeBase.ticketId) {
      const randomId = `KBA${Math.floor(10000 + Math.random() * 90000)}`;
      setKnowledgeBase((prev) => ({ ...prev, ticketId: randomId }));
    }
  }, []);

  return (
    <div className="incident-form">
      <section className="form-section">
        <h3>Knowledge Base Information</h3>
        <div className="grid">
          <Input
            readOnly
            type="text"
            label="Ticket ID"
            value={knowledgeBase.ticketId || ""}
            onChange={() => {}}
          />
          <Input
            type="text"
            label="Created By"
            value={knowledgeBase.createdby ?? ""}
            onChange={(val) => handleChange("createdby", val)}
            readOnly
          />
          {/* <Input
            type="datetime-local"
            label="Ticket Creation Date/Time"
            value={knowledgeBase.ticketCreation}
            onChange={(val) => handleChange("ticketCreation", val)}
          /> */}
          {/* <Input
            type="datetime-local"
            label="Ticket Closure Date/Time"
            value={knowledgeBase.ticketClosure}
            onChange={(val) => handleChange("ticketClosure", val)}
          /> */}
          {/* <ApiDropdown
            api="users"
            labelKey="username"
            valueKey="id"
            label="User"
            onChange={async (val) => {
              handleChange("userid", val);
              try {
                const res = await authFetch(
                  `${config.apiBaseUrl}/api/users/${val}`
                );
                if (!res.ok) throw new Error("User not found");
                const user = await res.json();
                handleChange("", user.email);
              } catch (err) {
                console.error("Error fetching user:", err);
              }
            }}
          /> */}

          {/* <Input type="datetime-local" label="Ticket creation" value={knowledgeBase.ticketCreation} onChange={(val) => handleChange('ticketCreation', val)} /> */}
          {/* <Input type="datetime-local" label="Ticket closure" value={knowledgeBase.ticketClosure} onChange={(val) => handleChange('ticketClosure', val)} /> */}
          {/* <Input
            type="datetime-local"
            label="KnowledgeBase start"
            required={true}
            value={knowledgeBase.knowledgeBaseStartDatetime}
            onChange={(val) => handleChange("knowledgeBaseStartDatetime", val)}
          /> */}
          <Input
            type="text"
            label="Ticket Cross Reference Number"
            value={knowledgeBase.ticketcrossrefrencenumber}
            onChange={(val) => handleChange("ticketcrossrefrencenumber", val)}
          />
        </div>
      </section>

      <section className="form-section">
        <h3>Customer & Network</h3>
        <div className="grid">
          {!isAdmin && (
            <ApiDropdown
              api="affected-customers"
              required={true}
              labelKey="customername"
              disabled
              value={organization}
              valueKey="customername"
              label="Customer"
              isMulti
              onOpen={async () => {
                try {
                  const responseIds = await authFetch(
                    `${config.apiBaseUrl}/api/users/id-by-organization?organization=${organization}`
                  );
                  if (!responseIds.ok)
                    throw new Error(
                      `HTTP error! status: ${responseIds.status}`
                    );
                  const userIds = await responseIds.json();

                  const userIdsParam = Array.isArray(userIds)
                    ? userIds.join(",")
                    : userIds;
                  const responseEmails = await authFetch(
                    `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                  );
                  if (!responseEmails.ok)
                    throw new Error(
                      `HTTP error! status: ${responseEmails.status}`
                    );
                  const emails = await responseEmails.json();
                  setEmails(emails);
                  //console.log("Fetched emails:", emails);

                  handleChange("foruserid", userIds);

                  handleChange("affectedCustomer", [organization]);
                } catch (error) {
                  console.error("Failed to fetch customer or emails:", error);
                }
              }}
            />
          )}
          {isAdmin && (
            <ApiDropdown
              api="affected-customers"
              labelKey="customername"
              required={true}
              valueKey="customername"
              label="Customer"
              isMulti
              onChange={async (val) => {
                setCustomer(val);
                //console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", val);
                handleChange("affectedCustomer", val);
                try {
                  const responseIds = await authFetch(
                    `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`
                  );
                  if (!responseIds.ok)
                    throw new Error(
                      `HTTP error! status: ${responseIds.status}`
                    );
                  const userIds = await responseIds.json();
                  //console.log("Fetched user IDs:", userIds);

                  const userIdsParam = Array.isArray(userIds)
                    ? userIds.join(",")
                    : userIds;
                  const responseEmails = await authFetch(
                    `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                  );
                  if (!responseEmails.ok)
                    throw new Error(
                      `HTTP error! status: ${responseEmails.status}`
                    );
                  const emails = await responseEmails.json();
                  setEmails(emails);
                  //console.log("Fetched emails:", emails);

                  handleChange("foruserid", userIds);
                } catch (error) {
                  console.error("Failed to fetch customer or emails:", error);
                }
              }}
            />
          )}
          {!isAdmin && organization && (
            <ApiDropdown
              api={`everything/networks?customer=${organization}`}
              labelKey="label"
              valueKey="value"
              label=" Networks"
              required={true}
              isMulti
              onChange={(val) => {
                setNetwork(val);
                handleChange("affectedNetwork", val);
              }}
            />
          )}

          {!isAdmin && organization && (
            <>
              {network && (
                <ApiDropdown
                  api={`everything/sites?customer=${organization}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label=" Site"
                  isMulti
                  onChange={(val) => {
                    setSite(val);
                    handleChange("affectedSite", val);
                  }}
                />
              )}

              {site && (
                <ApiDropdown
                  api={`everything/links?customer=${organization}&network=${network}&site=${site}`}
                  labelKey="label"
                  valueKey="value"
                  label=" Link"
                  isMulti
                  onChange={(val) => handleChange("affectedLink", val)}
                />
              )}

              <ApiDropdown
                api={`everything/asset?customer=${organization}&network=${network}`}
                labelKey="label"
                valueKey="value"
                label="Assets"
                isMulti
                onChange={(val) => handleChange("asset", joinMulti(val))}
              />
            </>
          )}

          {isAdmin && (
            <>
              {customer && (
                <ApiDropdown
                  api={`everything/networks?customer=${customer}`}
                  labelKey="label"
                  valueKey="value"
                  required={true}
                  label="Networks"
                  isMulti
                  onChange={(val) => {
                    setNetwork(val);
                    handleChange("affectedNetwork", val);
                  }}
                />
              )}

              {network && (
                <ApiDropdown
                  api={`everything/sites?customer=${customer}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Site"
                  isMulti
                  onChange={(val) => {
                    setSite(val);
                    handleChange("affectedSite", val);
                  }}
                />
              )}

              {site && (
                <ApiDropdown
                  api={`everything/links?customer=${customer}&network=${network}&site=${site}`}
                  labelKey="label"
                  valueKey="value"
                  label="Link"
                  isMulti
                  onChange={(val) => handleChange("affectedLink", val)}
                />
              )}

              <ApiDropdown
                api={`everything/asset?customer=${customer}&network=${network}`}
                labelKey="label"
                valueKey="value"
                label="Assets"
                isMulti
                onChange={(val) => handleChange("asset", joinMulti(val))}
              />
            </>
          )}
        </div>
      </section>

      <section className="form-section">
        <h3>Knowledge Base Details</h3>
        <div className="grid2">
          <TextArea
            label="Summary"
            required={true}
            value={knowledgeBase.summary}
            style={{
              minHeight: "30px",
              minWidth: "90%",
              backgroundColor: "white",
            }}
            onChange={(val) => handleChange("summary", val)}
          />
          <TextArea
            label="Description"
            required={true}
            value={knowledgeBase.description}
            style={{
              minHeight: "100px",
              minWidth: "90%",
              backgroundColor: "white",
            }}
            onChange={(val) => handleChange("description", val)}
          />

          <TextArea
            label="Solution"
            value={knowledgeBase.solution || ""}
            style={{
              minHeight: "100px",
              minWidth: "90%",
              backgroundColor: "white",
            }}
            onChange={(val) => handleChange("solution", val)}
          />
          <ApiDropdown
            api="ClosureCodes"
            labelKey="name"
            valueKey="name"
            value={knowledgeBase.closurecode}
            label="Closure Code"
            onChange={(val) => handleChange("closurecode", val)}
          />
          <div style={{paddingTop:"30px"}}>
            <TextArea
              label="Root Cause"
              value={knowledgeBase.rootcause}
              onChange={(val) => handleChange("rootcause", val)}
              style={{
                minHeight: "100px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
            />
          </div>
        </div>
      </section>

      <section className="form-section">
        <h3>Related Object</h3>
        <div className="grid">
          <>
            <FileUploader
              value={knowledgeBase.filePath}
              onRemove={(path) =>
                handleChange("filePath", (knowledgeBase.filePath || []).filter((p: any) => p !== path))
              }
              onChange={async (files, paths) => {
                if (!files || !paths.length) return;

                const uploadedPaths: string[] = [];

                for (let i = 0; i < files.length; i++) {
                  const formData = new FormData();
                  formData.append("file", files[i]);

                  try {
                    const response = await authFetch(
                      `${config.apiBaseUrl}/api/tasks/upload`,
                      {
                        method: "POST",
                        body: formData,
                      }
                    );

                    if (response.ok) {
                      const { path } = await response.json();
                      uploadedPaths.push(path);
                    } else {
                      console.error(`Upload failed for file: ${files[i].name}`);
                    }
                  } catch (error) {
                    console.error("Error uploading file", error);
                  }
                }

                if (uploadedPaths.length) {
                  handleChange("filePath", [
                    ...(knowledgeBase.filePath || []),
                    ...uploadedPaths,
                  ]);
                }
              }}
            />
            {isAdmin && (
              <>
                <button onClick={handleOpenTaskLookup}>
                  Select Related Ticket
                </button>
                {selectedTask && selectedTask.length > 0 && (
                  <div>
                    <p>
                      <strong>Selected Tasks:</strong>
                    </p>
                    <ul>
                      {selectedTask.map((task, index) => (
                        <li key={index}>{task.ticketId}</li>
                      ))}
                    </ul>
                  </div>
                )}
                <TaskGridLookup
                  isOpen={isTaskLookupOpen}
                  onClose={handleCloseTaskLookup}
                  onSelect={handleTaskSelect}
                  selectedItems={selectedTask}
                />{" "}
              </>
            )}
          </>
        </div>
      </section>
      <div className="submit-section">
        <button onClick={handleSubmit}>Submit KnowledgeBase</button>
      </div>
    </div>
  );
};

export default KnowledgeBaseAdd;
